import { render } from "preact";
import { LazyCss } from "../components/css";

const H2 = ({ children }) => <h2 class="text-2xl md:text-3xl font-medium monorail-header mt-4 md:mt-8">{children}</h2>

const H3 = ({ children }) => <h3 class="text-xl md:text-2xl font-medium monorail-header mt-4 md:mt-8">{children}</h3>

const P = ({ children }) => <p class="mt-3 leading-7">{children}</p>

const PSub = ({ children }) => <p class="mt-3 leading-6 text-sm">{children}</p>

const Link = ({ href, children }) => <a href={href} class="underline decoration-2 underline-offset-4 decoration-blue-300 hover:decoration-blue-500 transition">{children}</a>

const SOC2 = () => {
  return (
    <>
      <LazyCss url="https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" />
      <LazyCss url="https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap" />

      <div class="bg-monorail min-h-full p-2 md:p-8 monorail-sans">
        <section class="bg-gray-50 max-w-3xl m-auto p-6 md:p-8 shadow-lg rounded-sm">
          <h1 class="text-2xl md:text-3xl font-semibold monorail-header">
            Low-stress SOC 2 for startups
          </h1>

          <p class="mt-4 md:mt-8 text-xl leading-8">
            Monorail provides hands-on SOC 2 help for startups going through it for the first time.
          </p>

          <H2>Stop worrying.</H2>

          <P>
            Going through any audit for the first time is stressful. You want somebody who can
            explain how the process works, knows what really matters, and can get you set up with the
            tools you need to be successful.
          </P>

          <H2>Don't waste your time.</H2>

          <P>
            You've got better things to do than learn GRC platforms,
            figure out what auditors really care about, create a principled
            security program from scratch, and project manage a high stakes process you've never led before.
          </P>

          <H2>Do things that make sense.</H2>

          <P>Compliance can sometimes be a box-checking exercise, but security risks are real. Monorail helps
            develop and implement pragmatic, right-sized approaches that are informed by what your auditors
            and customers want to see, what your real world risks are, and what you can reasonably support
            with the team you have.</P>

          <H2>Get real work done.</H2>

          <P>Monorail does hands-on compliance and security. You won't just get a list of recommendations&mdash;you'll
            get a partner who will move projects forward. I'll evaluate and configure tools, draft policies,
            run tabletops, triage pen test results, and keep work on track.</P>

          <H2>Get great tools with excellent pricing.</H2>

          <P>Monorail has relationships with best in class compliance platforms, auditors,
            pen testing firms, and security education platforms. Depending on what you need,
            I may be able to provide significantly better pricing than you'd get directly from vendors.</P>

          <hr class="mt-6 md:mt-10 mb-6 w-8/12 m-auto opacity-20"/>

          <H3>Working with Monorail</H3>

          <PSub>After you <a href="contact">fill out the contact form</a>, I'll send you some questions about your
            current security and governance practices that relate specifically to SOC 2. Then I'll schedule
            a free review meeting where we'll discuss your goals and timeline in more detail, I'll give high level
            advice about what's most important to address, and then I'll follow up with a proposal and quote to get
            you through the SOC 2 process with confidence.
          </PSub>

          <H3>Why trust Monorail?</H3>

          <PSub>Monorail Technology is run by{" "}
            <a class="underline underline-offset-4 decoration-2 decoration-purple-300 hover:decoration-purple-500 transition" href="https://linkedin.com/in/jkriss" target="_blank">Jesse Kriss</a>,
            a pioneer in user-focused security who was the first security hire at <Link href="https://watershed.com">Watershed</Link>, where he built out the security, compliance, and IT
            programs and toolsets from scratch, carried them through multiple successful audits, and ensured that multiple
            Fortune 500 companies had high confidence in Watershed's security practices.
          </PSub>
          <PSub>
            Prior to Watershed, he spent 6.5 years on the security team at Netflix, widely known to be among the best in the business.
          </PSub>
          <PSub>Beyond Watershed and Netflix, Jesse has experience working at companies from 3 to 300,000 people, including PricewaterhouseCoopers, IBM Research,
            the Obama 2012 Tech Team, and NASA/JPL.
          </PSub>

          <a href="contact" class="btn btn-primary mt-8 mb-4 w-full sm:w-auto text-lg">Get in touch &rarr;</a>
        </section>
      </div>
    </>)
}

render(<SOC2 />, document.querySelector("main"));
